module.exports = __webpack_public_path__ + "img/code_img.9434365d.jpg";